import { Fade } from "@mui/material";
import cn from "classnames";
import useTranslate from "../../hooks/useTranslate";
import ProgressCircle from "../ProgressCircle/ProgressCircle";
import { IBlockWithLoadingProps } from "./BlockWithLoading.props";
import styles from "./BlockWithLoading.module.scss";

const BlockWithLoading = ({ title = "title_loading", withBackground = false, inLine = false, ...props }: IBlockWithLoadingProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Fade in={true} timeout={500}>
			<div className={styles.loading} {...props}>
				<div className={cn({ [styles.loadingWithBackground]: withBackground })}>
					<ProgressCircle title={translate(title)} inLine={inLine} />
				</div>
			</div>
		</Fade>
	);
};

export default BlockWithLoading;
